<!-- dcr-card with menu-->
@if (!data.eduContent.isScorable && !data.eduContent.isVideo) {
  <dcr-card
    [headline]="data.eduContent.publishedEduContentMetadata.title"
    [attr.leading-icon]="eduContentIconsMap.get(data.eduContent.id)"
    header-orientation="horizontal"
    [ariaSelected]="selected"
    [elevated]="selected"
    [attr.color]="selected ? 'secondary' : undefined"
    >
    <ng-container
      [ngTemplateOutlet]="actions"
    [ngTemplateOutletContext]="{
      data: data,
      eduContent: data.eduContent,
      primaryAction: primaryActionMap.get(data.eduContent.id),
      secondaryActions: secondaryActionsMap.get(data.eduContent.id)
    }"
    ></ng-container>
  </dcr-card>
}

<!-- dcr-card if score -->
@if (data.eduContent.isScorable && !data.eduContent.isVideo) {
  <dcr-card
    [headline]="data.eduContent.publishedEduContentMetadata.title"
    [attr.leading-icon]="eduContentIconsMap.get(data.eduContent.id)"
    orientation="horizontal"
  [attr.hero-type]="
    (isStudent$ | async) && bestScoresMap.get(data.eduContent.id) !== null ? 'score' : undefined
  "
    [ariaSelected]="selected"
    [elevated]="selected"
    [attr.color]="selected ? 'secondary' : undefined"
    >
    @if ((isStudent$ | async) && bestScoresMap.get(data.eduContent.id) !== null) {
      <div slot="hero">
        <dcr-score
          [attr.value]="bestScoresMap.get(data.eduContent.id)"
          high-threshold="101"
          [attr.is-pending]="statusTaskMap.get(data.eduContent.id) || undefined"
        ></dcr-score>
      </div>
    }
    <ng-container
      [ngTemplateOutlet]="actions"
    [ngTemplateOutletContext]="{
      data: data,
      eduContent: data.eduContent,
      primaryAction: primaryActionMap.get(data.eduContent.id),
      secondaryActions: secondaryActionsMap.get(data.eduContent.id)
    }"
    ></ng-container>
  </dcr-card>
}

<!-- dcr-card if video -->
@if (data.eduContent.isVideo) {
  <dcr-card
    [headline]="data.eduContent.publishedEduContentMetadata.title"
    hero-type="video"
    >
    <iframe
      slot="hero"
      width="100%"
      height="100%"
      [src]="data.eduContent.publishedEduContentMetadata.link | safeUrl"
      [title]="data.eduContent.publishedEduContentMetadata.title"
      frameborder="0"
      allow="autoplay; encrypted-media; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </dcr-card>
}

<ng-template
  #actions
  let-data="data"
  let-eduContent="eduContent"
  let-primaryAction="primaryAction"
  let-secondaryActions="secondaryActions"
  >
  @if (primaryAction || secondaryActions?.length) {
    <div
      slot="actions"
      style="--dcr-comp-card-actions-justify-content: space-between"
      >
      <div></div>
      <div class="flex flex-wrap gap-2xs items-center justify-end">
        @if (secondaryActions?.length === 1) {
          <dcr-inline-button
            data-cy="search-result-action"
            [leadingIcon]="secondaryActions[0].icon ? 'content-open-actions:' + secondaryActions[0].icon : undefined"
            [label]="secondaryActions[0].label"
            (click)="handleAction(secondaryActions[0], eduContent)"
          ></dcr-inline-button>
        }
        @if (primaryAction) {
          <dcr-tonal-button
            color="secondary"
            [label]="primaryAction.label"
            [leadingIcon]="primaryAction.icon ? 'content-open-actions:' + primaryAction.icon : undefined"
            (click)="handleAction(primaryAction, eduContent)"
          ></dcr-tonal-button>
        }
        @if (secondaryActions.length > 1) {
          <div>
            <dcr-inline-icon-button
              data-cy="btn-tli-action"
              icon="shared:more"
              [id]="'trgi-more-' + eduContent.id"
            ></dcr-inline-icon-button>
            <dcr-menu
              [anchor]="'trgi-more-' + eduContent.id"
              positioning="popover"
              anchor-corner="end-end"
              menu-corner="start-end"
              >
              @for (action of secondaryActions; track action) {
                <dcr-menu-item
                  data-cy="search-result-action"
                  [leadingIcon]="'content-open-actions:' + action.icon"
                  [label]="action.label"
                  (click)="handleAction(action, eduContent)"
                ></dcr-menu-item>
              }
            </dcr-menu>
          </div>
        }
      </div>
    </div>
  }

  <div slot="header-action" *hasPermission="[[SettingsPermissions.MANAGE_TASKS, SettingsPermissions.MANAGE_BUNDLES]]">
    @if (eduContent.taskAllowed && (canManageTaskContentV2$ | async) === true) {
      <dcr-checkbox
        data-cy="checkbox-toc-result"
        class="toc-result-list-item__checkbox"
        [checked]="selected"
        (change)="onSelectionChange($event.target.checked, data)"
      ></dcr-checkbox>
    }
  </div>
</ng-template>
